import Button from "../Form/Button/Button";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { ConfirmModalWrapper, PopupBody, PopupContainer, PopupModal, PopupFooter, PopupHeader, PopupForm } from "./Components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { useDataTable } from "../../hooks/useDataTable";
import FormInput from "../Form/FormInput/FormInput";
import { Form, Formik } from "formik";
import YupValidation from "../Form/Validations/YupValidaion";
import FormDatePicker from "../Form/DatePicker/FormDatePicker";
import moment from "jalali-moment";
import { FormSelect } from "../Form/FormInput/FormSelect";
import { getCurrentDayOfMonth, getFirstDayOfMonth } from "../../helper";
export const DATA_TABLE_FILTER = {
    INPUT: 1,
    DATE_RANGE: 2,
    CHOOSE_OPTIONS: 3,
    REPORT_DATE: 4
}
export default function FilterPopup(){
    const {t} = useTranslation();
    const {closeFilterPopup, fieldOpenFilterModal, appendFilter, filterConfig, clearFilter} = useDataTable();
    let initialValues = {};
    let validationSchema = Yup.object({});
    if(fieldOpenFilterModal.filter === DATA_TABLE_FILTER.INPUT){
        initialValues = {
            [fieldOpenFilterModal.key]: filterConfig[fieldOpenFilterModal.key],
        }
        validationSchema = Yup.object({ 
            [fieldOpenFilterModal.key]: YupValidation.EmptyValidation(fieldOpenFilterModal.label)
        });
    }
    if(fieldOpenFilterModal.filter === DATA_TABLE_FILTER.DATE_RANGE){
        initialValues = {
            [fieldOpenFilterModal.key]: filterConfig[fieldOpenFilterModal.key]??[null,null],
        }
        validationSchema = Yup.object({
            [fieldOpenFilterModal.key]: Yup.array().of(YupValidation.EmptyValidation(fieldOpenFilterModal.label)) 
        });
    }
    if(fieldOpenFilterModal.filter === DATA_TABLE_FILTER.CHOOSE_OPTIONS){
        initialValues = {
            [fieldOpenFilterModal.key]: filterConfig[fieldOpenFilterModal.key],
        }
        validationSchema = Yup.object({ 
            [fieldOpenFilterModal.key]: YupValidation.EmptyValidation(fieldOpenFilterModal.label)
        });
    }
    if(fieldOpenFilterModal.filter === DATA_TABLE_FILTER.REPORT_DATE){
        initialValues = {
            "type": filterConfig[fieldOpenFilterModal.key].type,
            "from": filterConfig[fieldOpenFilterModal.key]?.from??getFirstDayOfMonth(),
            "to": filterConfig[fieldOpenFilterModal.key]?.to??getCurrentDayOfMonth(),
            "month": filterConfig[fieldOpenFilterModal.key].month??8,
            "year": filterConfig[fieldOpenFilterModal.key].year??2025,
        }
        
    }

    const handleSubmit = (values, actions) => {
        if(fieldOpenFilterModal.filter === DATA_TABLE_FILTER.DATE_RANGE){
            let date = [];
            date.push(moment(values[fieldOpenFilterModal.key][0]).format("YYYY-MM-DD"));
            date.push(moment(values[fieldOpenFilterModal.key][1]).format("YYYY-MM-DD"));
            appendFilter(fieldOpenFilterModal.key, date);
            closeFilterPopup();
            return;
        }
        if(fieldOpenFilterModal.filter === DATA_TABLE_FILTER.REPORT_DATE){
            if(values.type === "range"){
                appendFilter(fieldOpenFilterModal.key, {
                    type: values.type,
                    from: moment(values.from).format("YYYY-MM-DD"),
                    to: moment(values.to).format("YYYY-MM-DD")
                });
            }else if(values.type === "month"){
                appendFilter(fieldOpenFilterModal.key, {
                    type: values.type,
                    month: values.month,
                    year: values.year
                });
            }else if(values.type === "year"){
                appendFilter(fieldOpenFilterModal.key, {
                    type: values.type,
                    year: values.year
                });
            }
            
            closeFilterPopup();
            return;
        }
        appendFilter(fieldOpenFilterModal.key, values[fieldOpenFilterModal.key]);
        closeFilterPopup();
    };
    const onClose = (e) => {
        closeFilterPopup();
    }
    return (
        <PopupContainer>
            <PopupModal>
                <ConfirmModalWrapper>
                    <PopupBody>
                        <PopupHeader><FontAwesomeIcon icon={faFilter} /> {t("Filter")}</PopupHeader>
                        <PopupForm>
                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                            >
                                {(formik) => (
                                    <Form>
                                        {fieldOpenFilterModal.filter === DATA_TABLE_FILTER.INPUT && (
                                            <FormInput type="text" name={fieldOpenFilterModal.key} label={fieldOpenFilterModal.label} theme={"light"} forceLTR={true} formik={formik}/>
                                        )}
                                        {fieldOpenFilterModal.filter === DATA_TABLE_FILTER.DATE_RANGE && (
                                            <>
                                                <FormDatePicker theme={"light"} name={fieldOpenFilterModal.key+"[0]"} label={t("Start date")} formik={formik} forceLTR={true} />
                                                <FormDatePicker theme={"light"} name={fieldOpenFilterModal.key+"[1]"} label={t("End date")} formik={formik} forceLTR={true} />
                                            </>
                                        )}
                                        {fieldOpenFilterModal.filter === DATA_TABLE_FILTER.CHOOSE_OPTIONS && (
                                            <>
                                                <FormSelect theme={"light"} name={fieldOpenFilterModal.key} label={fieldOpenFilterModal.label} formik={formik}>
                                                    <option value={""} >{t("Please choose...")}</option>
                                                    {fieldOpenFilterModal.options && fieldOpenFilterModal.options.map((option, index) => {
                                                        return (<option value={option.key} key={index} >{option.value}</option>)
                                                    })}
                                                </FormSelect>
                                            </>
                                        )}
                                        {fieldOpenFilterModal.filter === DATA_TABLE_FILTER.REPORT_DATE && (
                                            <>
                                                <FormSelect theme={"light"} name={"type"} label={t("Type")} formik={formik} key={"type"}>
                                                    <option value={""} >{t("Please choose...")}</option>
                                                    <option value={"range"}>{t("Range of dates")}</option>
                                                    <option value={"month"}>{t("Monthly")}</option>
                                                    <option value={"year"}>{t("Yearly")}</option>
                                                </FormSelect>
                                                {(formik.values.type === "range") && (
                                                    <>
                                                        <FormDatePicker theme={"light"} name={"from"} label={t("Start date")} formik={formik} forceLTR={true} />
                                                        <FormDatePicker theme={"light"} name={"to"} label={t("End date")} formik={formik} forceLTR={true} />
                                                    </>
                                                )}
                                                {(formik.values.type === "month") && (
                                                    <>
                                                        <FormSelect theme={"light"} name={"month"} label={t("Month")} formik={formik} key={"month"}>
                                                            {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month, index) => (
                                                                <option key={index + 1} value={index + 1}>
                                                                {month}
                                                                </option>
                                                            ))}
                                                        </FormSelect>
                                                        <FormSelect theme={"light"} name={"year"} label={t("Year")} formik={formik} key={"year"}>
                                                            {Array.from({ length: new Date().getFullYear() - 2025 + 1 }, (_, i) => 2025 + i).map((year) => (
                                                                <option key={year} value={year}>
                                                                {year}
                                                                </option>
                                                            ))}
                                                        </FormSelect>
                                                    </>
                                                )}
                                                {(formik.values.type === "year") && (
                                                    <>
                                                        <FormSelect theme={"light"} name={"year"} label={t("Year")} formik={formik} key={"year"}>
                                                            {Array.from({ length: new Date().getFullYear() - 2025 + 1 }, (_, i) => 2025 + i).map((year) => (
                                                                <option key={year} value={year}>
                                                                {year}
                                                                </option>
                                                            ))}
                                                        </FormSelect>
                                                    </>
                                                )}
                                                
                                            </>
                                        )}
                                        <PopupFooter>
                                            <Button type={"submit"} variant={"primary"}>{t("Filter")}</Button>
                                            <Button variant={"outline-primary"} onClick={onClose}>{t("Close")}</Button>
                                        </PopupFooter>
                                    </Form>
                                )}
                            </Formik>
                        </PopupForm>
                    </PopupBody>
                </ConfirmModalWrapper>
            </PopupModal>
            
        </PopupContainer>
    )
}